import type { TranslationFn } from '@mentimeter/question-modules-types';
import { Text } from '@mentimeter/ragnar-ui/text';
import { StringParser } from '@mentimeter/string-parser';

const ellipsis = () => ({
  'text-overflow': 'ellipsis',
  'white-space': 'nowrap',
  overflow: 'hidden',
});

interface QfaTitleProps {
  askedOnSlideTitle: string | undefined;
  displayName: string | null;
  translationFn: TranslationFn;
}

export const QfaTitle = ({
  askedOnSlideTitle,
  displayName,
  translationFn,
}: QfaTitleProps) => {
  if (!askedOnSlideTitle && !displayName) {
    return null;
  }

  return (
    <Text
      mb="space6"
      data-testid="qfa-title"
      color="text"
      fontSize="175"
      textAlign="center"
      extend={ellipsis}
    >
      {askedOnSlideTitle && displayName && (
        <>
          <Text fontSize="175" color="textWeaker">
            {translationFn('qfa.asked_by_on', {
              displayName,
            })}
          </Text>{' '}
          <StringParser
            source={askedOnSlideTitle}
            disableLineBreaks
            allowHyperlinks
          />
        </>
      )}

      {!askedOnSlideTitle && displayName && (
        <Text fontSize="175" color="textWeaker">
          {translationFn('qfa.asked_by', {
            displayName,
          })}
        </Text>
      )}

      {askedOnSlideTitle && !displayName && (
        <>
          <Text fontSize="175" color="textWeaker">
            {translationFn('qfa.asked_on')}
          </Text>{' '}
          <StringParser
            source={askedOnSlideTitle}
            disableLineBreaks
            allowHyperlinks
          />
        </>
      )}
    </Text>
  );
};
